document.addEventListener('DOMContentLoaded', function () {
    class ProductMediaSmall extends HTMLElement {
        constructor() {
            super();
            this.mainSliderElement = this.querySelector('[data-product-slider]');
            this.thumbsSliderElement = this.querySelector('[data-product-thumbs]');

            this.mainSlider = {
                element: this.mainSliderElement,
                instance: null,
                options: {
                    pagination: false,
                    rewind: true,
                    drag: true,
                    speed: 300,
                    type: 'loop',
                    arrows: true,
                    autoHeight: false
                }
            };

            if (window.innerWidth < 768) {
                this.mainSlider.options.pagination = true
            } else {
                this.mainSlider.options.pagination = false
            }


            this.thumbsSlider = {
                element: this.thumbsSliderElement,
                instance: null,
                options: {
                    pagination: false,
                    rewind: true,
                    drag: true,
                    fixedWidth: `64px`,
                    isNavigation: true,
                    // direction: 'ttb',
                    height: `96px`,
                    perPage: '3',
                    gap: '16px',
                    speed: 300
                }
            };

            this.initSliders();
        }

        initSliders() {
            if (this.thumbsSlider.element) {
                this.thumbsSlider.instance = new Splide(this.thumbsSlider.element, this.thumbsSlider.options).mount();
            }

            if (this.mainSlider.element) {
                this.mainSlider.instance = new Splide(this.mainSlider.element, this.mainSlider.options);
                if (this.thumbsSlider.instance) {
                    this.mainSlider.instance.sync(this.thumbsSlider.instance).mount();
                } else {
                    this.mainSlider.instance.mount();
                }
            }
        }
    }

    // Define the custom element for each slider
    customElements.define('product-media-small', ProductMediaSmall);

    // Ensure that all sliders are initialized
    document.querySelectorAll('product-media-small').forEach((slider) => {
        if (!slider.classList.contains('initialized')) {
            slider.classList.add('initialized');
            new ProductMediaSmall();
        }
    });
});
